export default "__VITE_ASSET__53b2ac45__"